import { baseApi } from '../baseApi';

import { OrderDeviceTarget } from './OrderDeviceTarget';
import { WorkstationOrderDevice } from './WorkstationOrderDevice';

const slice = baseApi
  .enhanceEndpoints({
    addTagTypes: ['WorkstationOrderDevices', 'OrderDeviceTargets'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOrderDevices: builder.query<WorkstationOrderDevice[], void>({
        query: () => ({
          url: `/workstation-order-devices`,
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'WorkstationOrderDevices' as const,
                  id,
                })),
                { type: 'WorkstationOrderDevices', id: 'LIST' },
              ]
            : [{ type: 'WorkstationOrderDevices', id: 'LIST' }],
      }),
      getOrderDeviceTargets: builder.query<OrderDeviceTarget[], void>({
        query: () => ({
          url: `/workstation-order-devices/order-devices`,
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'OrderDeviceTargets' as const,
                  id,
                })),
                { type: 'OrderDeviceTargets', id: 'LIST' },
              ]
            : [{ type: 'OrderDeviceTargets', id: 'LIST' }],
      }),
      updateOrderDevice: builder.mutation<void, WorkstationOrderDevice>({
        query: (wod: WorkstationOrderDevice) => ({
          url: `/workstation-order-devices/${wod.id}${wod.overrideOrderDeviceId ? `?orderDeviceId=${wod.overrideOrderDeviceId}` : ''}`,
          method: 'POST',
        }),
        invalidatesTags: [{ type: 'WorkstationOrderDevices' }],
      }),
    }),
  });

export const {
  useGetOrderDevicesQuery,
  useLazyGetOrderDevicesQuery,
  useGetOrderDeviceTargetsQuery,
  useLazyGetOrderDeviceTargetsQuery,
  useUpdateOrderDeviceMutation,
} = slice;
